import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';

export const DictionaryOperationLoadDetailsActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[dictionary/operation] Load details'),
  requestFail: uniqueActionType('[dictionary/operation] Load details fail'),
  requestSuccess: uniqueActionType('[dictionary/operation] Load details success'),
  requestClearErrors: uniqueActionType('[dictionary/operation] Load details clear errors'),
  requestClear: uniqueActionType('[dictionary/operation] Load details clear')
};

export class DictionaryOperationLoadDetailsAction implements PayloadAction {
  readonly type = DictionaryOperationLoadDetailsActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryOperationLoadDetailsFailAction implements PayloadAction {
  readonly type = DictionaryOperationLoadDetailsActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class DictionaryOperationLoadDetailsSuccessAction implements PayloadAction {
  readonly type = DictionaryOperationLoadDetailsActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class DictionaryOperationLoadDetailsClearAction implements PayloadAction {
  readonly type = DictionaryOperationLoadDetailsActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryOperationLoadDetailsClearErrorsAction implements PayloadAction {
  readonly type = DictionaryOperationLoadDetailsActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}
